<template>
  <PainelLayout>
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <h1>Painel</h1>
      <RentalSearch />
    </div>
    <p class="section-label mb-3">Visão geral</p>
    <div class="row g-3 mb-4">
      <div class="col-12 col-lg-6">
        <div class="row g-3 h-100">
          <!-- Itens -->
          <div class="col-12 col-sm-6">
            <div class="card metric-card card-blue border h-100">
              <div v-if="!base_loading" class="card-body p-3 d-flex flex-column">
                <div class="card-icon icon-blue mb-3">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#185FA5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2"/>
                    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
                    <line x1="12" y1="12" x2="12" y2="16"/>
                    <line x1="10" y1="14" x2="14" y2="14"/>
                  </svg>
                </div>
                <div class="card-value mb-1">{{ itens_quant }}</div>
                <p class="text-secondary mb-3" style="font-size:12px;">Itens no catálogo</p>
                <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
                  <router-link class="card-link" to="/stock">Ver todos →</router-link>
                </div>
              </div>
              <div v-else class="spinner-border mx-auto my-auto" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>

          <!-- Clientes -->
          <div class="col-12 col-sm-6">
            <div class="card metric-card card-teal border h-100">
              <div v-if="!base_loading" class="card-body p-3 d-flex flex-column">
                <div class="card-icon icon-teal mb-3">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <div class="card-value mb-1">{{ client_quant }}</div>
                <p class="text-secondary mb-3" style="font-size:12px;">Clientes cadastrados</p>
                <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
                  <router-link class="card-link" to="/client">Ver todos →</router-link>
                </div>
              </div>
              <div v-else class="spinner-border mx-auto my-auto" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>

          <!-- Locações -->
          <div class="col-12 col-sm-6">
            <div class="card metric-card card-purple border h-100">
              <div v-if="!base_loading" class="card-body p-3 d-flex flex-column">
                <div class="card-icon icon-purple mb-3">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#534AB7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </div>
                <div class="card-value mb-1">{{ rentals_30d_quant }}</div>
                <p class="text-secondary mb-3" style="font-size:12px;">Locações no mês</p>
                <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
                  <router-link class="card-link" to="/rental">Ver todas →</router-link>
                </div>
              </div>
              <div v-else class="spinner-border mx-auto my-auto" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>

          <!-- Receita -->
          <div class="col-12 col-sm-6">
            <div class="card metric-card card-amber border h-100">
              <div v-if="!base_loading" class="card-body p-3 d-flex flex-column">
                <div class="card-icon icon-amber mb-3">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#854F0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="1" x2="12" y2="23"/>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                  </svg>
                </div>
                <div class="card-value money mb-1">R$ {{ total_30d.toFixed(2) }}</div>
                <p class="text-secondary mb-3" style="font-size:12px;">Receita dos últimos 30 dias</p>
              </div>
              <div v-else class="spinner-border mx-auto my-auto" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Coluna direita: o gráfico -->
      <div class="col-12 col-lg-6">
        <div class="card chart-card border h-100">
          <div class="card-body p-3 d-flex flex-column">
            <p class="section-label mb-3">Receita por dia (mês atual)</p>
            <div v-if="base_loading" class="d-flex justify-content-center align-items-center flex-grow-1">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-show="!base_loading" class="flex-grow-1" style="min-height: 280px;">
              <canvas ref="chartCanvas"></canvas>
            </div>
          </div>
        </div>
      </div>

    </div>

    <p class="section-label mb-3">Locações — status</p>
    <div class="row g-3">

      <!-- Agendadas -->
      <div class="col-12 col-sm-6 col-xl">
        <div class="card metric-card card-gray border h-100">
          <div v-if="!rentals_loading" class="card-body p-3 d-flex flex-column">
            <div class="card-icon icon-gray mb-3">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5F5E5A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <div class="card-value mb-1">{{rentals.scheduled}}</div>
            <p class="text-secondary mb-3" style="font-size:12px;">Agendadas</p>
            <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
              <router-link class="card-link" to="/rental">Ver →</router-link>
            </div>
          </div>
          <div v-else class="spinner-border mx-auto my-auto" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <!-- Entregar -->
      <div class="col-12 col-sm-6 col-xl">
        <div class="card metric-card card-blue border h-100">
          <div v-if="!rentals_loading" class="card-body p-3 d-flex flex-column">
            <div class="card-icon icon-blue mb-3">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#185FA5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="3" width="15" height="13" rx="1"/>
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
                <circle cx="5.5" cy="18.5" r="2.5"/>
                <circle cx="18.5" cy="18.5" r="2.5"/>
              </svg>
            </div>
            <div class="card-value mb-1">{{ rentals.delivery }}</div>
            <p class="text-secondary mb-3" style="font-size:12px;">Para entregar</p>
            <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
              <router-link class="card-link" to="/rental">Ver →</router-link>
            </div>
          </div>
          <div v-else class="spinner-border mx-auto my-auto" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <!-- Locações ativas -->
      <div class="col-12 col-sm-6 col-xl">
        <div class="card metric-card card-teal border h-100">
          <div v-if="!rentals_loading" class="card-body p-3 d-flex flex-column">
            <div class="card-icon icon-teal mb-3">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <div class="card-value mb-1">{{ rentals.active }}</div>
            <p class="text-secondary mb-3" style="font-size:12px;">Locações em andamento</p>
            <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
              <router-link class="card-link" to="/rental">Ver →</router-link>
            </div>
          </div>
          <div v-else class="spinner-border mx-auto my-auto" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <!-- Recolher -->
      <div class="col-12 col-sm-6 col-xl">
        <div class="card metric-card card-coral border h-100">
          <div v-if="!rentals_loading" class="card-body p-3 d-flex flex-column">
            <div class="card-icon icon-coral mb-3">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993C1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="1 4 1 10 7 10"/>
                <path d="M3.51 15a9 9 0 1 0 .49-3.6"/>
              </svg>
            </div>
            <div class="card-value mb-1">{{ rentals.pickup }}</div>
            <p class="text-secondary mb-3" style="font-size:12px;">Para recolher</p>
            <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
              <router-link class="card-link" to="/rental">Ver →</router-link>
            </div>
          </div>
          <div v-else class="spinner-border mx-auto my-auto" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <!-- Concluídas -->
      <div class="col-12 col-sm-12 col-xl">
        <div class="card metric-card card-green border h-100">
          <div v-if="!rentals_loading" class="card-body p-3 d-flex flex-column">
            <div class="card-icon icon-green mb-3">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <div class="card-value mb-1">{{rentals.completed}}</div>
            <p class="text-secondary mb-3" style="font-size:12px;">Concluídas nos últimos 30 dias</p>
            <div class="card-footer-line pt-3 mt-auto d-flex align-items-center justify-content-between">
              <a class="card-link" href="#">Ver →</a>
            </div>
          </div>
          <div v-else class="spinner-border mx-auto my-auto" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Bloco principal -->
    <div class="mb-2 mt-4">
      <p class="section-label mb-3">Últimas ações</p>
    </div>

    <!--type, note, description, created_at user- id- name, id-rental -->

    <app-table empty-message='nada encontrado'
    :colunas="[{ label: 'Tipo' }, { label: 'Descrição' }, {label: 'Data'},{label: 'Usuário'}, {label: ''}]">
      <app-trow
        v-for="item in last_action" :key="item.id"
        :data="[
          {value: statusFormat.type(item.type)},
          {value: item.description},
          {value: dateFormat.dateTime(item.created_at)},
          {value: item.user.name}
        ]"
      >
      <template #actions>
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/rental/details', query: { id: item.id_rental } }">
          <i class="bi bi-file-earmark-text me-2"></i>Ver +
        </router-link>
      </template>
      </app-trow>
    </app-table>

    
  <div class="margin-footer"></div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { usePermissions } from '@/composables/usePermissions.js';
import { onMounted, reactive, ref, onBeforeMount, nextTick } from 'vue';
import { painel } from '@/models/painel';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';
import RentalSearch from '@/components/RentalSearch.vue';
import statusFormat from '@/services/statusFormat';
import dateFormat from '@/services/dateFormat';
import router from '@/router';
import { Chart, LineController, LineElement, PointElement, CategoryScale, LinearScale, Tooltip } from 'chart.js';

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Tooltip);

export default {
  name: "PainelView",
  components: { PainelLayout, AppTable, AppTrow, RentalSearch },
  setup(props) {
    const { isAdmin, hasLevel, can, userLevel, isOpeto } = usePermissions();
    const painelmodel = painel();
    const chartCanvas = ref(null);
    let chartInstance = null;

    var base_loading = ref(true);
    var actions_loading = ref(true);
    var rentals_loading = ref(true);

    var itens_quant = ref(0);
    var client_quant = ref(0);
    var rentals_30d_quant = ref(0);
    var total_30d = ref(0);

    var last_action = ref([]);

    var rentals = reactive({
        delivery : 0,
        pickup : 0,
        scheduled : 0,
        completed : 0,
        active : 0
    });

    function formatarLabelDia(dataStr) {
      // "2026-08-08" -> "08/08"
      const partes = dataStr.split('-');
      return `${partes[2]}/${partes[1]}`;
    }

    function renderChart(totalPorDia) {
      if (!totalPorDia || !chartCanvas.value) return;

      const labels = Object.keys(totalPorDia).map(formatarLabelDia);
      const valores = Object.values(totalPorDia);

      if (chartInstance) {
        chartInstance.data.labels = labels;
        chartInstance.data.datasets[0].data = valores;
        chartInstance.update();
        return;
      }

      chartInstance = new Chart(chartCanvas.value.getContext('2d'), {
        type: 'line',
        data: {
          labels,
          datasets: [{
            label: 'Receita (R$)',
            data: valores,
            borderColor: '#378ADD',
            backgroundColor: 'rgba(55, 138, 221, 0.12)',
            pointBackgroundColor: '#378ADD',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 6,
            borderWidth: 2.5,
            tension: 0.35,
            fill: true
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (ctx) => `R$ ${ctx.parsed.y.toFixed(2)}`
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => `R$ ${value}`
              }
            }
          }
        }
      });
    }

    async function getBase() {
      const response = await painelmodel.getBase();
      if (response) {
        itens_quant.value = response.itens_quant;
        client_quant.value = response.client_quant;
        total_30d.value = response.total_30d;
        rentals_30d_quant.value = response.rentals_30d_quant;

        await nextTick(); // garante que o v-show já liberou o canvas no DOM
        renderChart(response.total_por_dia);
      }
      base_loading.value = false;
    }

    async function getLastActions() {
      const response = await painelmodel.getLastActions();
      if (response) {
        last_action.value = response.last_action;
      }
      actions_loading.value = false;
    }

    async function getRentals() {
      const response = await painelmodel.getRentals();
      if (response) {
        rentals.scheduled = response.scheduled
        rentals.active = response.active
        rentals.completed = response.completed
        rentals.delivery = response.delivery
        rentals.pickup = response.pickup
      }
      rentals_loading.value = false;
    }

    onBeforeMount(() => {
      if(isOpeto.value) {return router.push('/route');}
    })

    onMounted(() => {
      getBase();
      getRentals();
      getLastActions();
    })
    
    return {
      isAdmin, hasLevel, can, statusFormat, dateFormat,
      userLevel, base_loading, actions_loading, rentals_loading, getRentals, getLastActions,
      last_action, rentals_30d_quant, client_quant, itens_quant, rentals, total_30d,
      chartCanvas
    };
  }
}
</script>

<style scoped>

  body { font-family: 'Sora', sans-serif; background: #f5f5f3; }

  .margin-footer {
    height: 20px;
  }
  
  .chart-card {
    border-radius: 16px !important;
    border: 0.5px solid rgba(0,0,0,0.08) !important;
  }

  .section-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #9a9a9a;
  }

  .metric-card {
    border: 0.5px solid rgba(0,0,0,0.08) !important;
    border-radius: 16px !important;
    transition: transform 0.18s ease, border-color 0.18s ease;
    overflow: hidden;
    position: relative;
  }

  .metric-card:hover {
    transform: translateY(-2px);
    border-color: rgba(0,0,0,0.18) !important;
  }

  .metric-card::before {
    content: '';
    display: block;
    height: 3px;
    width: 100%;
  }

  .card-blue::before   { background: linear-gradient(90deg, #378ADD, #85B7EB); }
  .card-teal::before   { background: linear-gradient(90deg, #1D9E75, #5DCAA5); }
  .card-purple::before { background: linear-gradient(90deg, #534AB7, #AFA9EC); }
  .card-amber::before  { background: linear-gradient(90deg, #BA7517, #EF9F27); }
  .card-coral::before  { background: linear-gradient(90deg, #D85A30, #F0997B); }
  .card-green::before  { background: linear-gradient(90deg, #3B6D11, #97C459); }
  .card-gray::before   { background: linear-gradient(90deg, #5F5E5A, #B4B2A9); }

  .card-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-blue   { background: #E6F1FB; }
  .icon-teal   { background: #E1F5EE; }
  .icon-purple { background: #EEEDFE; }
  .icon-amber  { background: #FAEEDA; }
  .icon-coral  { background: #FAECE7; }
  .icon-green  { background: #EAF3DE; }
  .icon-gray   { background: #F1EFE8; }

  .card-value {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1;
    letter-spacing: -0.03em;
  }

  .card-value.money {
    font-family: 'JetBrains Mono', monospace;
    font-size: 22px;
  }

  .card-footer-line {
    border-top: 0.5px solid rgba(0,0,0,0.07);
  }

  .card-link {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #9a9a9a;
    text-decoration: none;
    transition: color 0.15s;
  }
  .card-link:hover { color: #1a1a1a; }

  .badge-up   { background: #EAF3DE !important; color: #3B6D11 !important; }
  .badge-warn { background: #FAEEDA !important; color: #854F0B !important; }
  .badge-neu  { background: #F1EFE8 !important; color: #5F5E5A !important; }

</style>